import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import { getProjects } from "../requests/projects.requests";
import { GetProjectsParams } from "../../types/project";

export const useGetProjects = (params?: GetProjectsParams, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROJECTS, params?.destination, params?.task_kind],
    queryFn: () => getProjects(params),
    enabled,
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
};
